import React, { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';
import { useTranslator } from 'components/shared/hooks/useTranslator/useTranslator';

type ConfirmExitPromptProps = {
  when: boolean;
  message?: string;
};

/**
 * Replacement for react-router v5 <Prompt>. Requires a data router (createBrowserRouter).
 */
export const ConfirmExitPrompt: React.FC<ConfirmExitPromptProps> = ({ when, message }) => {
  const trans = useTranslator();
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => when && currentLocation.pathname !== nextLocation.pathname,
  );

  useEffect(() => {
    if (!when && blocker.state === 'blocked') {
      blocker.proceed?.();
    }
  }, [when, blocker]);

  const open = blocker.state === 'blocked';

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>{trans('COMMON.CONFIRM_EXIT')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message || trans('COMMON.CONFIRM_EXIT')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => blocker.reset?.()} color="primary">
          {trans('COMMON.CANCEL')}
        </Button>
        <Button onClick={() => blocker.proceed?.()} color="primary" variant="contained" autoFocus>
          {trans('COMMON.YES')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
